import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import i18next from 'i18next';

import Timestamp from '../Timestamp';
import { formatAsISO } from '../../lib/DateTime';

function ContentTimestamp(props, context) {
  const {
    dateCreated, // publish
    datePublished, // update, this is expected
    dateOnly,
    delimiter,
    layout,
    meta,
    showCreatedDate,
    styles,
  } = props;

  if (datePublished === '') {
    return null;
  }

  const contentHasBeenUpdated = dateCreated !== datePublished;
  const lastUpdatedDateString = contentHasBeenUpdated ? datePublished : dateCreated;

  const showUpdatedTimestamp = (!showCreatedDate || contentHasBeenUpdated);
  const shouldRenderLastPublishedMetaTag = (meta && contentHasBeenUpdated);
  const shouldRenderCreatedMetaTag = (meta && showCreatedDate);

  // Amp articles are rendered server side.
  // As such we do not have access to the clients
  // timezone. Rather than display UTC we explicitly
  // set date to be formatted in eastern time.
  const { amp: isAmpArticle } = context;
  const ianaEasternTimeZone = 'America/New_York';
  const timeZone = isAmpArticle ? ianaEasternTimeZone : undefined;

  const dateCreatedISOString = formatAsISO(dateCreated); // Only needed for meta tag
  const lastUpdatedISODateString = formatAsISO(datePublished);

  return (
    <>
      <time
        className={classNames('relative z-1', styles)}
        dateTime={lastUpdatedDateString}
        data-test="timestamp__datePublished"
        itemProp="datePublished"
        content={lastUpdatedISODateString}
      >
        {showCreatedDate && (
          <Timestamp
            dateOnly={dateOnly}
            dateString={dateCreated}
            delimiter={delimiter}
            layout={layout}
            timeZone={timeZone}
          />
        )}

        {showUpdatedTimestamp
          && (
            <>
              {showCreatedDate && <span>&nbsp;/&nbsp;</span>}
              {i18next.t('Updated')}
              &nbsp;
              <Timestamp
                dateOnly={dateOnly}
                dateString={lastUpdatedDateString}
                delimiter={delimiter}
                layout={layout}
                timeZone={timeZone}
              />
            </>
          )}
      </time>

      {shouldRenderCreatedMetaTag && (
        <meta
          data-test="timestamp__datePublished--meta"
          itemProp="datePublished"
          content={dateCreatedISOString}
        />
      )}

      {shouldRenderLastPublishedMetaTag && (
        <meta
          data-test="timestamp__dateModified--meta"
          itemProp="dateModified"
          content={lastUpdatedISODateString}
        />
      )}
    </>
  );
}

ContentTimestamp.propTypes = {
  dateCreated: PropTypes.string,
  dateOnly: PropTypes.bool,
  datePublished: PropTypes.string,
  delimiter: PropTypes.string,
  layout: PropTypes.string,
  meta: PropTypes.bool,
  showCreatedDate: PropTypes.bool,
  styles: PropTypes.string,
};

ContentTimestamp.defaultProps = {
  dateCreated: '',
  dateOnly: false,
  datePublished: '',
  delimiter: '',
  layout: '',
  meta: false,
  showCreatedDate: false,
  styles: '',
};

ContentTimestamp.contextTypes = {
  amp: PropTypes.bool,
};

export default ContentTimestamp;
